/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useId, type ReactNode } from 'react';

import { css, cssMap, jsx } from '@compiled/react';

import type { SVGProps } from '@atlaskit/icon/types';

const sizeStyles = cssMap({
	small: {
		width: '12px',
		height: '12px',
	},
	medium: {
		width: '24px',
		height: '24px',
	},
	large: {
		width: '32px',
		height: '32px',
	},
	xlarge: {
		width: '48px',
		height: '48px',
	},
});

const svgStyles = css({
	overflow: 'hidden',
	pointerEvents: 'none',
});

export const SuggestionIcon = (props: SVGProps & { children?: ReactNode }): JSX.Element => {
	const { size = 'large', label } = props;
	const clipPathId = useId();
	return (
		<svg
			css={[svgStyles, sizeStyles[size]]}
			fill="none"
			viewBox="0 0 16 16"
			aria-label={label}
			role={label ? 'img' : 'presentation'}
		>
			<defs>
				<clipPath id={clipPathId}>
					<path d="M8.11719 1.00879C8.38352 1.05062 8.61063 1.23423 8.70508 1.49316L10.2549 5.74414L14.5068 7.29492C14.8027 7.40285 14.9998 7.6841 15 7.99902V8.00098C14.9998 8.3159 14.8027 8.59715 14.5068 8.70508L10.2549 10.2549L8.70508 14.5068C8.59715 14.8027 8.3159 14.9998 8.00098 15H7.99902C7.6841 14.9998 7.40285 14.8027 7.29492 14.5068L5.74414 10.2549L1.49316 8.70508C1.19728 8.59715 1.00018 8.3159 1 8.00098V7.99902C1.00018 7.6841 1.19728 7.40285 1.49316 7.29492L5.74414 5.74414L7.29492 1.49316L7.34277 1.38672C7.47321 1.15076 7.72343 1.00016 7.99902 1H8.00098L8.11719 1.00879Z" />
				</clipPath>
			</defs>
			<g clipPath={`url(#${clipPathId})`}>
				<foreignObject x="0" y="0" width="16" height="16" transform="rotate(-45 8 8)">
					{props.children}
				</foreignObject>
			</g>
		</svg>
	);
};
